/**
 * The colour key for one series, shared by the legend and the tooltip.
 *
 * A LINE rather than a dot, and that is not cosmetic: the Search Progress tab
 * plots every stage a search has on an eight-hue scale, so `stageSeriesStyle`
 * gives each one a `stroke-dasharray` as a second channel and two indigo stages
 * are told apart by their dash. A plain dot would show them as the same colour
 * and the legend would stop being a key. The donut and the funnel key the same
 * tier with a hatched dot (`StageHatch.tsx`), because a filled arc has no
 * stroke to dash.
 *
 * Shared so the two places a reader looks up a colour cannot disagree — a
 * tooltip whose swatch was solid where the legend's was dashed would be worse
 * than no swatch at all.
 */

export interface SeriesSwatchProps {
  /** Tailwind `stroke-*` utility resolving to a `--chart-*` token. */
  strokeClass: string;
  /** SVG `stroke-dasharray`; empty or absent means solid. */
  dash?: string;
}

export function SeriesSwatch({ strokeClass, dash }: SeriesSwatchProps) {
  return (
    <svg viewBox="0 0 16 4" aria-hidden="true" className="h-1 w-4 shrink-0 overflow-visible">
      <line
        x1={0}
        y1={2}
        x2={16}
        y2={2}
        strokeWidth={2}
        strokeDasharray={dash || undefined}
        className={strokeClass}
      />
    </svg>
  );
}
